// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"smart-devices-teaser_productcontent__rhoLT"};